import styles from './Input.module.scss'
import PonderaSelect from './select'

export default function Input({ name, min, max, pondera, step = 0.1, text }) {
	return (
		<div className={styles.container}>
			<label htmlFor={name} className='e5'>
				<span className={styles.labelText}>{text}</span>
			</label>
			<div>
				{pondera && <PonderaSelect name={`${name}_pondera`} />}
				<input
					type='number'
					id={name}
					name={name}
					placeholder='0,0'
					min={min}
					max={max}
					step={step}
					required={!pondera}
				/>
			</div>
		</div>
	)
}
